'use strict';

/* global $ */

import { fancybox } from '../settings';

function Gallery(options) {
    let opt = $.extend({
        selector: '.js-fancy, a[rel="lightbox"]'
    }, options);

    $(opt.selector).fancybox($.extend(true, {}, fancybox, opt.fancybox));

}
 
export {
    Gallery
};